import { api } from "../api";
import axios from "axios";

export const Signup = async (formData) => {
    const response = await axios.post(api + 'register', formData);
    return response.data;
};

export const resendVerification = async (token) => {
    const response = await axios.post(
        api + 'email/verification-notification',
        {},
        {
            headers: { 'Authorization': `Bearer ${token}` }
        }
    );
    return response.data;
};

export const verifyEmail = async (id, hash, expires, signature, token) => {
    const response = await axios.get(
        `${api}email/verify/${id}/${hash}?expires=${expires}&signature=${signature}`,
        {
            headers: { 'Authorization': `Bearer ${token}` }
        }
    );
    return response.data;
};